export const URI_ADMIN_ACCOUNT = 'admin/account';
